import { Component, OnDestroy, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit, OnDestroy {
  private header: HTMLElement | null = null;
  private isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    if (this.isBrowser) {
      try {
        const token = localStorage.getItem('accessToken');

        // If the logged-in user is a Company, redirect to company home page
        if (token) {
          const userInfoRaw = localStorage.getItem('userInfo');
          if (userInfoRaw) {
            const userInfo = JSON.parse(userInfoRaw);
            const role = userInfo?.role;
            const roleName = typeof role === 'object' && role !== null
              ? role.name
              : role;
            if (roleName?.toString().toUpperCase() === 'COMPANY') {
              this.router.navigate(['/company-home']);
              return;
            }
          }
        }
        // Guests (no token) are allowed to stay on /home
      } catch {}

      if (typeof document !== 'undefined') {
        this.header = document.querySelector('.header');
      }

      if (window.scrollY > 30) {
        this.header?.classList.add('scrolled');
      } else {
        this.header?.classList.remove('scrolled');
      }

      window.onscroll = () => {
        if (this.header) {
          if (window.scrollY > 30) {
            this.header.classList.add('scrolled');
          } else {
            this.header.classList.remove('scrolled');
          }
        }
      };
    }
  }

  ngOnDestroy() {
    if (this.isBrowser && window) {
      window.onscroll = null;
      this.header?.classList.add('scrolled');
    }
  }
}
